import { Divider, Menu, MenuItem, Typography } from "@mui/material";

interface GridSizeMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onGridSizeChange: (size: 4 | 6 | 8 | 12) => void;
  children?: React.ReactNode;
}

export default function GridSizeMenu({
  anchorEl,
  onClose,
  onGridSizeChange,
  children,
}: GridSizeMenuProps) {
  const handleSizeChange = (size: 4 | 6 | 8 | 12) => {
    onGridSizeChange(size);
    onClose();
  };

  const sizeOptions = [
    { size: 4, label: "Quarter Width" },
    { size: 6, label: "Half Width" },
    { size: 8, label: "Middle Width" },
    { size: 12, label: "Full Width" },
  ];

  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
      <MenuItem disabled>
        <Typography variant="subtitle2">Size Options</Typography>
      </MenuItem>
      {sizeOptions.map(({ size, label }) => (
        <MenuItem
          key={size}
          onClick={() => handleSizeChange(size as 4 | 6 | 8 | 12)}
        >
          {label}
        </MenuItem>
      ))}
      {children && <Divider />}
      {children}
    </Menu>
  );
}
